module.exports = __webpack_public_path__ + "img/thumb_28.77cfcc23.jpg";